/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Removing_Repeat_Words_FailedInputs */

const en_removing_repeat_words_failed = /** @type {(inputs: Removing_Repeat_Words_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Removing repeat words failed. ${i?.error}`)
};

const fr_removing_repeat_words_failed = /** @type {(inputs: Removing_Repeat_Words_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suppression des mots répétés échouée. ${i?.error}`)
};

const de_removing_repeat_words_failed = /** @type {(inputs: Removing_Repeat_Words_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das Entfernen von doppelten Wörtern ist fehlgeschlagen. ${i?.error}`)
};

const it_removing_repeat_words_failed = /** @type {(inputs: Removing_Repeat_Words_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rimozione delle parole ripetute non riuscita. ${i?.error}`)
};

const ru_removing_repeat_words_failed = /** @type {(inputs: Removing_Repeat_Words_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Удаление повторяющихся слов не удалось. ${i?.error}`)
};

const es_removing_repeat_words_failed = /** @type {(inputs: Removing_Repeat_Words_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al eliminar palabras repetidas. ${i?.error}`)
};

const zh_cn2_removing_repeat_words_failed = /** @type {(inputs: Removing_Repeat_Words_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`删除重复词失败。${i?.error}`)
};

const ja_removing_repeat_words_failed = /** @type {(inputs: Removing_Repeat_Words_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`重複した単語の削除に失敗しました。${i?.error}`)
};

const hi_removing_repeat_words_failed = /** @type {(inputs: Removing_Repeat_Words_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`दोहराए गए शब्दों को हटाने में विफलता। ${i?.error}`)
};

const pt_pt2_removing_repeat_words_failed = /** @type {(inputs: Removing_Repeat_Words_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A remoção de palavras repetidas falhou. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Removing repeat words failed. {error}" |
*
* @param {Removing_Repeat_Words_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const removing_repeat_words_failed = /** @type {((inputs: Removing_Repeat_Words_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Removing_Repeat_Words_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_removing_repeat_words_failed(inputs)
	if (locale === "de") return de_removing_repeat_words_failed(inputs)
	if (locale === "it") return it_removing_repeat_words_failed(inputs)
	if (locale === "ru") return ru_removing_repeat_words_failed(inputs)
	if (locale === "es") return es_removing_repeat_words_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_removing_repeat_words_failed(inputs)
	if (locale === "ja") return ja_removing_repeat_words_failed(inputs)
	if (locale === "hi") return hi_removing_repeat_words_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_removing_repeat_words_failed(inputs)
	return en_removing_repeat_words_failed(inputs)
});